import JelentkezesForm from "../components/JelentkezesForm";

function Jelentkezes() {
  return (
    <>
      <JelentkezesForm />
    </>
  );
}

export default Jelentkezes;
